import { useState, useRef } from 'react';
import { supabase } from '../supabaseClient.js';
import { BrowserMultiFormatReader } from '@zxing/browser';

export default function ScanPage() {
  const [serial, setSerial] = useState('');
  const [unit, setUnit] = useState(null);
  const [message, setMessage] = useState('');
  const [scanning, setScanning] = useState(false);

  const videoRef = useRef(null);
  const codeReader = new BrowserMultiFormatReader();

  // 🔹 TEMP USER (change based on testing)
  const userId = 'd615b47f-747b-4955-bdd3-c7673ffd5c79'; // distributor

  // 🔍 EXISTING LOGIC (UNCHANGED)
  const handleSubmit = async (scannedValue = null) => {
    const value = scannedValue || serial;
    setMessage('');
    if (!value) return;

    const { data, error } = await supabase
      .from('units')
      .select(
        `
        id,
        serial_number,
        current_owner_org_id,
        organizations!units_current_owner_org_id_fkey(id, name, type)
      `,
      )
      .eq('serial_number', value)
      .single();

    if (error) {
      console.error(error);
      setUnit(null);
      setMessage('❌ Carton not found');
      return;
    }

    setUnit(data);

    const { data: profile } = await supabase
      .from('profiles')
      .select(
        `
        id,
        organization_id,
        organizations:organizations(id, name, type)
      `,
      )
      .eq('id', userId)
      .single();

    const userOrgType = profile.organizations.type;
    const ownerOrgType = data.organizations.type;

    if (profile.organization_id === data.current_owner_org_id) {
      setMessage('⚠️ Already owned by your organization');
      return;
    }

    const validFlow = {
      manufacturer: 'distributor',
      distributor: 'retailer',
    };

    if (validFlow[ownerOrgType] !== userOrgType) {
      setMessage('❌ Invalid transfer flow');
      return;
    }

    setMessage('✅ Ready to receive');
  };

  // 🔥 START SCANNER
  const startScanner = async () => {
    setScanning(true);

    try {
      const devices = await codeReader.listVideoInputDevices();
      const selectedDeviceId = devices[0]?.deviceId;

      codeReader.decodeFromVideoDevice(
        selectedDeviceId,
        videoRef.current,
        (result, err) => {
          if (result) {
            const text = result.getText();
            console.log('Scanned:', text);

            setSerial(text);
            setScanning(false);
            codeReader.reset();

            // 🔥 AUTO TRIGGER FLOW
            handleSubmit(text);
          }
        },
      );
    } catch (error) {
      console.error(error);
    }
  };

  // 🔥 STOP SCANNER
  const stopScanner = () => {
    codeReader.reset();
    setScanning(false);
  };

  // 🔥 RECEIVE ACTION
  const handleReceive = async () => {
    if (!unit) return;

    const { data: profile } = await supabase
      .from('profiles')
      .select('id, organization_id')
      .eq('id', userId)
      .single();

    const { error } = await supabase.from('events').insert([
      {
        unit_id: unit.id,
        from_org_id: unit.current_owner_org_id,
        to_org_id: profile.organization_id,
        action: 'RECEIVED',
        performed_by: profile.id,
      },
    ]);

    if (error) {
      console.error(error);
      alert('Receive failed');
    } else {
      alert('Received successfully');
      setSerial('');
      setUnit(null);
      setMessage('');
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial' }}>
      <h2>📦 Scan Carton</h2>

      {/* 🔥 CAMERA SECTION */}
      <div style={{ marginTop: '20px' }}>
        {!scanning ? (
          <button onClick={startScanner}>📷 Start Scan</button>
        ) : (
          <>
            <video
              ref={videoRef}
              style={{ width: '300px', border: '1px solid #ccc' }}
            />
            <br />
            <button onClick={stopScanner} style={{ marginTop: '10px' }}>
              Stop Scan
            </button>
          </>
        )}
      </div>

      {/* 🔹 Manual fallback */}
      <div style={{ marginTop: '20px' }}>
        <input
          type="text"
          placeholder="Enter serial manually"
          value={serial}
          onChange={(e) => setSerial(e.target.value)}
          style={{ padding: '10px', width: '300px', marginRight: '10px' }}
        />
        <button onClick={() => handleSubmit()}>Submit</button>
      </div>

      {/* RESULT */}
      {unit && (
        <div style={{ marginTop: '30px' }}>
          <h3>📦 Result</h3>

          <p>
            <strong>Serial:</strong> {unit.serial_number}
          </p>

          <p>
            <strong>Owner:</strong> {unit.organizations?.name}
          </p>
        </div>
      )}

      {/* MESSAGE */}
      {message && (
        <p style={{ marginTop: '15px', fontWeight: 'bold' }}>{message}</p>
      )}

      {/* RECEIVE BUTTON */}
      {message === '✅ Ready to receive' && (
        <button
          onClick={handleReceive}
          style={{ marginTop: '15px', padding: '10px 20px' }}
        >
          Receive
        </button>
      )}
    </div>
  );
}
